import React from 'react';
import PropTypes from 'prop-types';

const Initials = ({ firstName, lastName }) => {
    // Get initials from first and last name
    const getInitials = () => {
        const first = firstName?.charAt(0) || '';
        const last = lastName?.charAt(0) || '';
        return (first + last).toUpperCase();
    };

    // Generate a consistent color based on initials
    const getColor = () => {
        const colors = ['bg-red-500', 'bg-blue-500', 'bg-green-500', 'bg-yellow-500', 'bg-purple-500', 'bg-pink-500', 'bg-indigo-500', 'bg-teal-500'];

        const initials = getInitials();
        const colorIndex = Math.abs(initials.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)) % colors.length;

        return colors[colorIndex];
    };

    return <div className={`${getColor()} w-6 h-6 rounded-full flex items-center justify-center text-white text-xs font-medium`}>{getInitials()}</div>;
};

Initials.propTypes = {
    firstName: PropTypes.string,
    lastName: PropTypes.string
};

export default Initials;
